export default __webpack_public_path__ + "static/media/polygon-logo.e9cb7235.svg";